import { MagpieConnection } from 'magpie-lib/connection';
import { AudienceFilter } from 'magpie-lib/models';
import { useEffect } from 'react';
import { useEventCallback } from '../hooks/useEventCallback';
import { getHubSpotWindowInfo } from './hubspotWindow';
import Raven from 'raven-js';
const getSessionIdFromURL = win => new URLSearchParams(win.location.search).get('sessionId');
export const getMagpieSessionId = win => {
  try {
    const sessionIdFromUrl = getSessionIdFromURL(win);
    if (sessionIdFromUrl) {
      return sessionIdFromUrl;
    }
    const {
      sessionId
    } = getHubSpotWindowInfo(win) || {};
    if (sessionId) {
      return sessionId;
    }
    Raven.captureException(new Error('Unable to get magpie session id'), {
      extra: {
        hubspotWindowInfo: window.hubspot,
        search: win.location.search,
        origin: win.location.origin
      }
    });
    return null;
  } catch (error) {
    Raven.captureException(error, {
      extra: {
        hubspotWindowInfo: window.hubspot,
        search: win.location.search,
        origin: win.location.origin
      }
    });
    return null;
  }
};
export const CollaborationSidebarSessionId = getMagpieSessionId(window);
export const buildAudience = () => {
  const builder = AudienceFilter.builder().crossTab(false).crossPortal(true);
  return builder.build();
};
const getTopic = topic => {
  return MagpieConnection.get().forTopic(topic);
};
export const useMagpieTopic = ({
  topic,
  message,
  onMessage
}) => {
  'use memo';

  const skip = !onMessage;
  const stableOnMessage = useEventCallback(onMessage);
  useEffect(() => {
    if (skip) {
      return;
    }
    const unsubscribe = getTopic(topic).on(message.getType(), stableOnMessage);
    return () => unsubscribe();
  }, [message, skip, stableOnMessage, topic]);
};
export const CollaborationSidebarAudience = buildAudience();